/* eslint-disable react-hooks/rules-of-hooks */
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFieldValue } from "formik";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { ControlState } from "../models/flexible/control-state";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { ReasonsForDiscontinuation } from "../models/generated/graphql";
import { getEnumValues } from "../utils/get-enum-values";
import { renderRequiredMessage } from "../utils/render-required-message";
import { TrFun } from "../utils/types";
import { GeneralFieldController } from "./general-field-controller";

export class ReasonForDiscontinuationFieldController extends GeneralFieldController {
	override useControlState(): ControlState {
		const [patientEnrolledInTreatment] = useFieldValue(AttributeIdentifiers.PatientEnrolledInTreatment);
		return `${patientEnrolledInTreatment}` === "false" ? "enabled" : "hidden";
	}

	override createValidationRule(initialValues: unknown, translation: TrFun): Yup.AnySchema {
		return super
			.createFieldValidationRuleByDataType(translation)
			.nullable()
			.when([AttributeIdentifiers.PatientEnrolledInTreatment], ((isEnrolled: boolean | string, schema: Yup.DateSchema<any>) =>
				`${isEnrolled}` === "false"
					? schema.required(renderRequiredMessage(this.schema.attribute.identifier, translation))
					: schema) as any);
	}

	override useControlProps(): FlexControlProps {
		const { t } = useTranslation();
		const [patientEnrolledInTreatment] = useFieldValue(AttributeIdentifiers.PatientEnrolledInTreatment);

		const options = patientEnrolledInTreatment
			? []
			: getEnumValues(ReasonsForDiscontinuation).map((v) => ({
					label: t(v),
					value: v,
			  }));

		return {
			controlType: "combo",
			options,
		};
	}
}
